import { urls } from "../constants/app";
import request from "./utils/request";

export function changeStatusPointKuper (id, status, comment) {
    return dispatch => {
        const data = {
            id,
            status,
            comment,
        };

        dispatch({ type: 'SET_LOADER', field: 'points', value: true });
        return request({ method: 'post', url: `${urls.kuper}/changeStatusPointKuper`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'points', value: false });
            return response;
        })
        .catch(error => {
            dispatch({ type: 'SET_LOADER', field: 'points', value: false });
            return error
        });
    }
};

export function changeTimePointKuper (id, time) {
    return dispatch => {
        const data = {
            id,
            time
        }

        dispatch({ type: 'SET_LOADER', field: 'points', value: true });
        return request({ method: 'post', url: `${urls.kuper}/changeTimePointKuper`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'points', value: false });
            return response;
        })
        .catch(error => {
            dispatch({ type: 'SET_LOADER', field: 'points', value: false });
            return error
        });
    }
};

export function changeStopListKuper (pointId, goods) {
    return dispatch => {
        dispatch({ type: 'SET_LOADER', field: 'points', value: true });

        const getGoods = () => {
            const result = goods.map((good) => {
                return {
                    active: good.active,
                    offer_id: String(good.value),
                    outlet_id: String(pointId),
                }
            });

            return result;
        };

        const data = { data: getGoods() };

        return request({ method: 'post', url: `${urls.kuper}/changeStopListKuper`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'points', value: false });
            return response;
        })
        .catch(error => {
            dispatch({ type: 'SET_LOADER', field: 'points', value: false });
            return error
        });
    }
};

export function importCategoriesKuper() {
    return (dispatch, getState) => {
        const categories = getState().good.categories;
        dispatch({ type: 'SET_LOADER', field: 'goods', value: true });

        const getCategories = () => {
            const result = categories.filter((item) => !item.inner && !item.notIntegration)
            .map((category) => {
                return {
                    id: String(category.id),
                    name: String(category.title),
                    position: parseInt(category.priority),
                    status: category.status ? category.status : "ACTIVE",
                }
            });

            return result;
        };

        const data = { data: getCategories() };

        return request({ method: 'post', url: `${urls.kuper}/importCategoriesKuper`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'goods', value: false });
            return response;
        })
        .catch(error => {
            dispatch({ type: 'SET_LOADER', field: 'goods', value: false });
            return error
        });
    }
};

const getAtributesGoodsKuper = (item, isMod, parent) => {
    const attributes = [
        {
            attribute: 'is_option',
            values: [
               isMod ? "true" : "false",
            ],
        },
        {
            attribute: 'is_excisable',
            values: [
                item.excise ? "true" : "false",
            ],
        },
    ];

    const getItemWeight = (item, parent) => {
        if (!parent) return item.weight;
        if (!item.weight) return 0;
        return item.weight - parent.weight;
    }

    if (isMod ? (parent && parent.measure === 'gramm') : item.measure === 'gramm') {
        attributes.push(
            {
                attribute: 'weight_netto',
                values: [
                    String(getItemWeight(item, parent))
                ],
            },
            {
                attribute: 'weight_netto_unit',
                values: [
                    "G"
                ]
            }
        );
    } else if (isMod ? (parent && parent.measure === 'liter') : item.measure === 'liter') {
        attributes.push(
            {
                attribute: 'volume_netto',
                values: [
                    String(getItemWeight(item, parent))
                ],
            },
            {
                attribute: 'volume_netto_unit',
                values: [
                    "L"
                ]
            }
        );
    }

    return [...attributes];
} 

export function importGoodsKuper() {
    return (dispatch, getState) => {
        const goods = getState().good.list;
        dispatch({ type: 'SET_LOADER', field: 'goods', value: true });

        const getGoods = () => {
            const data = [];
            goods.filter((item) => !item.notIntegration && !item.category.notIntegration)
            .map((good) => {
                const getImage = (item) => {
                    if (item.imageAgg && item.imageAgg.url) {
                        return [{
                            name: item.imageAgg.name || 'img',
                            url: `https://sushibox.one/api${item.imageAgg.url}`,
                        }];
                    };

                    if (item.image && item.image.url) {
                        return [{
                            name: item.image.name || 'img',
                            url: `https://sushibox.one/api${item.image.url}`,
                        }];
                    };

                    return null;
                }
                
                data[data.length] = {
                    categories_ids: [good.category.id],
                    description: String(good.description),
                    id: String(good.id),
                    images: getImage(good),                    
                    name: String(good.name),
                    pack_type: "per_item",
                    items_per_pack: 1,
                    position: parseInt(-good.priority) || null,
                    status: good.active ? "ACTIVE" : "INACTIVE",
                    attributes: getAtributesGoodsKuper(good, false),
                }

                if (good.modifications && good.modifications.length > 0) {
                    good.modifications.map((mod) => {
                        if (mod.active) {
                            return data[data.length] = {
                                id: String(mod.id + '_mod'),
                                name: String(mod.title),
                                attributes: getAtributesGoodsKuper(mod, true, good),
                                status: mod.active ? "ACTIVE" : "INACTIVE",
                            };
                        }
                        return null;
                    })
                }

                return true;
            });

            return data;
        };

        const data = { data: getGoods() };

        return request({ method: 'post', url: `${urls.kuper}/importGoodsKuper`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'goods', value: false });
            return response;
        })
        .catch(error => {
            dispatch({ type: 'SET_LOADER', field: 'goods', value: false });
            return error
        });
    }
}

export function importModsGoodsKuper() {
    return (dispatch, getState) => {
        const goods = getState().good.list;
        dispatch({ type: 'SET_LOADER', field: 'goods', value: true });

        const getGoods = () => {
            const result = goods.filter((item) => !item.notIntegration && !item.category.notIntegration)
            .filter((good) => good.modifications && good.modifications.length > 0)
            .map((good) => {
                return {
                    base_offer_id: String(good.id),
                    id: `${String(good.modifications[0].id)}_${String(good.modifications[1].id)}`,
                    max_amount: 1,
                    min_amount: 1,
                    name: "Размер",
                    options: [
                        {
                            offer_id: String(good.modifications[0].id+"mod"),
                            selected: good.modifications[0].default ? true : false,
                        },
                        {
                            offer_id: String(good.modifications[1].id+"mod"),
                            selected: good.modifications[1].default ? true : false,
                        }
                    ]
                }
            });

            return result;
        };

        const data = { data: getGoods() };

        return request({ method: 'post', url: `${urls.kuper}/importModsGoodsKuper`, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'goods', value: false });
            return response;
        })
        .catch(error => {
            dispatch({ type: 'SET_LOADER', field: 'goods', value: false });
            return error
        });
    }
}

export function editPriceGoodsKuper() {
    return (dispatch, getState) => {
        const goods = getState().good.list;
        dispatch({ type: 'SET_LOADER', field: 'goods', value: true });

        const getGoods = () => {
            const getModPrice = (price, mod) => {
                if (mod.price === 0) return 0;
                if (!price) return 0;

                if (mod.condition === 'equal') return mod.price - price;
                if (mod.persent) {
                    const persentPrice = Math.round(price * (mod.price / 100));
                    if (mod.condition === 'plus') return persentPrice;
                    return `-${persentPrice}`;
                } else {
                    if (mod.condition === 'plus') return mod.price;
                    if (mod.condition === 'multiply') return (price * mod.price) - price;
                    return `-${mod.price}`;
                }
            }

            const data = []

            goods.filter((item) => !item.notIntegration && !item.category.notIntegration)
            .map((good) => {
                data[data.length] = {
                    offer_id: String(good.id),
                    price: {
                        amount: String(good.price),
                        currency: "RUB",
                    },
                    price_type: "BASE",
                    vat: String(good.vat || 'none')
                };                

                if (good.modifications && good.modifications.length > 0) {
                    good.modifications.map((mod) => {
                        if (mod.active) {
                            return data[data.length] = {
                                offer_id: String(mod.id+'_mod'),
                                price: {
                                    amount: String(getModPrice(good.price, mod)),
                                    currency: "RUB",
                                },
                                price_type: "BASE",
                                vat: String(mod.vat || good.vat || 'none')
                            };
                        }
                        return null;
                    })
                }
                return data;
            });

            return data;
        };

        const data = [...getGoods()];

        return request({ method: 'post', url: `${urls.kuper}/editPriceGoodsKuper`, data })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'goods', value: false });
                if (response.error) dispatch({ type: 'SET_ERROR', field: 'goods', value: response.error.message ? response.error.message : response.error.title || null})
                if (response.errors && response.errors.length > 0) {
                    const massages = response.errors.map((item) => item.message ? item.message : item.title || null);
                    dispatch({ type: 'SET_ERROR', field: 'goods', value: massages.join(', ')})
                }
                return response;
            })
            .catch((error) => {
                dispatch({ type: 'SET_LOADER', field: 'goods', value: false });
                return error
            });
    }
}